<template>
  <div class="informationForm-box">
      <el-dialog :title="title" :visible.sync="dialogVisible" width="640px" @close="resetForm">
          <el-form :model="dialogInfo" :rules="rules" ref="messageForm" label-width="120px">
              <el-form-item label="消息主题：" prop="title" v-if="!isReply">
                  <el-input v-model="dialogInfo.title" placeholder="请輸入消息主题" size="mini" v-if="!isReadOnly"></el-input>
                  <span v-else>{{dialogInfo.title}}</span>
              </el-form-item>
              <el-form-item label="消息类型：" prop="messageType" v-if="!isReply">
                  <el-radio-group v-model="dialogInfo.messageType" :disabled="isReadOnly">
                      <el-radio :label="item.value" v-for="(item, i) in messageTypeList" :key="i">{{item.label}}</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="选择合同：" prop="fname" v-if="!isBatch && !isReply">
                  <el-input style="width:100%;" @click.native="selectBill" v-model="dialogInfo.fname" :readonly="true" placeholder="请选择" size="small" ></el-input>
              </el-form-item>
              <el-form-item label="选择供应商：" prop="supplierIds" v-if="isBatch">
                  <el-select v-model="dialogInfo.supplierIds" placeholder="请选择" :multiple="true" collapse-tags>
                      <el-option v-for="item in supplierList" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item :label="messageContentTitle" prop="content">
                  <el-input v-model="dialogInfo.content" type="textarea" :rows="3" placeholder="请输入内容" v-if="!isReadOnly"></el-input>
                  <span v-else>{{dialogInfo.content}}</span>
              </el-form-item>
              <el-form-item label="附件：" prop="baseFileList">
                  <el-upload
                      multiple
                      v-if="!isReadOnly"
                      class="upload-demo"
                      :limit="20"
                      :action="uploadApi"
                      :file-list="dialogInfo.baseFileList"
                      :before-upload="beforeUpload"
                      :on-success="uploadedSuccess"
                      :on-error="uploadError"
                      :on-remove="removeFile"
                  > <!--multiple-->
                      <el-button size="mini"  type="primary">上 传</el-button>
                      <div slot="tip" class="el-upload__tip">上传附件不要超过100M.<br><span style="color:#ff0305">注意：附件上传出现绿色打勾标志，才表示上传成功</span></div>
                  </el-upload>
                  <template v-else>
                      <div v-if="!dialogInfo.baseFileList || dialogInfo.baseFileList.length==0" class="no-data-tip"></div>
                      <ul v-else>
                          <li v-for="li in dialogInfo.baseFileList" :key="li.id">
                              <a :href="downloadApi +'/show?path='+ li.filePath.replace('/opt/web/','')" target="_blank" :download="li.fileName">{{ li.fileName }}</a>
                          </li>
                      </ul>
                  </template>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="!isReadOnly">
              <el-button type="primary" size="mini" @click="sendMessage(true)" v-if="!isAppend && !isReply" :v-loading="btnLoading">保 存</el-button>
              <el-button type="primary" size="mini" @click="sendMessage(false)" :v-loading="btnLoading">发 送</el-button>
              <el-button @click="cancel" size="mini">取 消</el-button>
          </div>
          <div slot="footer" class="dialog-footer" v-else>
              <el-button @click="cancel" size="mini">关 闭</el-button>
          </div>
      </el-dialog>

      <el-dialog :close-on-click-modal="false" title="选择合同" :visible.sync="billDialog" width="720px" @close="resetBillForm" lock-scroll center >

            <div class="dialog-padding">

                <el-form inline :model="searchBillForm">
                    <el-form-item label="合同编号：">
                        <el-input size="mini" v-model="searchBillForm.contractBillId" placeholder="模糊搜索" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="合同名称：">
                        <el-input size="mini" v-model="searchBillForm.fname" placeholder="模糊搜索" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="签约时间：">
                        <el-date-picker size="mini" v-model="searchBillForm.dateArr" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleDateChange" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="default" size="mini" @click="resetBillForm">重 置</el-button>
                        <el-button size="small" type="primary" @click="getBillList" >搜 索</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="billList" size="mini" class="unit-list-table" @row-click="rowClick" border>
                    <el-table-column label="选择" align="center" width="50" type="index">
                        <template slot-scope="scope">
                            <el-radio :label="scope.row.fid" v-model="selectedBillId">&nbsp;</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同编号" prop="contractBillId">
                    </el-table-column>
                    <el-table-column label="合同名称" prop="fname">
                    </el-table-column>
                    <el-table-column label="合同金额" prop="taxPrice">
                    </el-table-column>
                    <el-table-column label="合同签约时间" prop="fsigndate">
                    </el-table-column>
                </el-table>

                <div class="block">
                    <el-pagination
                            background
                            layout="total,sizes, prev, pager, next, jumper"
                            prev-text="上一页"
                            next-text="下一页"
                            @size-change="handleSizeChange"
                            :page-size="billPager.pageSize"
                            :current-page="billPager.pageNum"
                            :total="billPager.count"
                            @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                </div>

            </div>
            <div class="btnGroup">
                <el-button type="primary" @click="submitBill">确定</el-button>
                <el-button @click="cancelBill">取消</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
    import util from '@/util';
    export default {
        name: 'informationForm',
        components: {},
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }],
                },
                title: '',
                messageTypeList: [
                    {
                        value: '0',
                        label: '合同'
                    },
                    {
                        value: '1',
                        label: '通知'
                    },
                    {
                        value: '2',
                        label: '维修'
                    },
                    {
                        value: '3',
                        label: '其他'
                    }
                ],
                uploadApi: `${util.baseUrl}rest/file/upload?type=2`,
                downloadApi: `${util.baseUrl}rest/file/down`,
                dialogVisible: false,
                dialogInfo: {
                    id: '', // 消息ID
                    messageResponseId: '',
                    messageId: '',
                    messageType: '',
                    supplierIds: [], // 供应商ID
                    readFlag: '',
                    title: '', // 消息主题
                    content: '', // 消息内容
                    baseFileList: [] // 上传的文件列表
                },
                messageContentTitle: '',
                btnLoading: false,
                isReply: false,
                isBatch: false,
                isAppend: false,
                isReadOnly: false,
                supplierList: [], // 供应商列表
                acceptFileTypes: ["gif", "jpg", "jpeg", "bmp", "gif", "tif", "dwt", "dwg", "dws", "dxf", "png", "txt", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "vsd", "mpp", "pdf", "rar", "zip", "7z"],
                rules: {
                    supplierIds: [
                        {required: true, message: '请选择供应商', trigger: 'change'}
                    ],
                    title: [
                        {required: true, message: '请输入消息主题', trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请输入消息内容', trigger: 'blur'}
                    ],
                    messageType: [
                        { required: true, message: '请选择消息类型', trigger: 'change' }
                    ]
                },
                billDialog: false,
                billList:[],
                billPager: {
                    pageNum: 1,
                    pageCount: 0,
                    pageSize: 10
                },
                searchBillForm:{
                    dateArr: [],
                    contractBillId:'',
                    fname:'',
                    startDate:'',
                    endDate:''
                },
                selectedBillId:'',
                selectedBillFname:''
            }
        },
        created() {

        },
        methods: {
            //日期选择回调
            handleDateChange(data) {
                if (data && data.length) {
                    this.searchBillForm.startDate = data[0] || '';
                    this.searchBillForm.endDate = data[1] || '';
                } else {
                    this.searchBillForm.startDate = '';
                    this.searchBillForm.endDate = '';
                }
            },
            // 选择合同 弹框
            selectBill: function () {
                this.getBillList();
                this.billDialog = true;
                if (!this.selectedBillId) {
                    this.selectedBillId = '';
                    this.selectedBillFname = '';
                }
            },
            getBillList() {
                let apiUrl = 'rest/api/msg/getMessageBill';
                let params = {
                    'supplierId':this.$root.stockId,
                    'contractBillId': this.searchBillForm.contractBillId,
                    'pageSize': this.billPager.pageSize,
                    'pageNum': this.billPager.pageNum,
                    'fname': this.searchBillForm.fname,
                    'startDate': this.searchBillForm.startDate,
                    'endDate': this.searchBillForm.endDate
                };
                this.$http.post(apiUrl, params).then((res)=>{
                    if(res.data.result) {
                        this.billList = res.data.value ? res.data.value.list : [];
                        this.billPager.count = res.data.value.count;
                    } else {
                        this.$message({message: 'Error: createMsg', type: 'error'})
                    }
                })
            },
            handleCurrentChange(val) {
                this.billPager.pageNum = val;
                this.getBillList();
            },
            handleSizeChange(val) {
                this.billPager.pageNum = 1;
                this.billPager.pageSize = val;
                this.getBillList();
            },
            // 重置所有表单数据
            resetBillForm: function() {

                this.billPager = {
                    pageNum: 1,
                    pageSize: 10
                }
                this.searchBillForm = {
                    dateArr: [],
                    contractBillId:'',
                    fname:'',
                    startDate:'',
                    endDate:''
                }
                this.getBillList();
            },
            rowClick(row){
                this.selectedBillId = row.fid;
                this.selectedBillFname = row.fname;
            },
            submitBill() {
                this.dialogInfo.fname = this.selectedBillFname;
                this.billDialog = false;
            },
            cancelBill() {
                this.selectedBillId = '';
                this.selectedBillFname = '';
                this.dialogInfo.fname = '';
                this.billDialog = false;
            },
            // 发送消息
            sendMessage(isSave) {
                if (this.isReply) { // 回复消息
                    this._replyMessage('messageForm');
                } else { // 新建消息
                    this._saveMessage('messageForm', isSave)
                }
            },
            // 回复消息
            _replyMessage(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({lock:true, background:'rgba(255,255,255,0.5)'});
                        let apiUrl = 'rest/api/msg/createResponse';
                        let params = {
                            'messageResponseId':this.dialogInfo.messageResponseId,
                            'messageId': this.dialogInfo.messageId,
                            'supplierId': this.$root.stockId,
                            'supplierName': this.dialogInfo.supplierName,
                            'reponseContent': this.dialogInfo.content,
                            'baseFileList': this.dialogInfo.baseFileList
                        };

                        this.$http.post(apiUrl, params).then((res)=>{
                            this.dialogVisible = false;
                            loading.close();
                            if(res.data.result) {
                                this.$message({message: '提交成功', type: 'success'});
                                // 更新列表页面
                                this.$emit('refresh');
                            } else {
                                this.$message({message: 'Error: createMsg', type: 'error'})
                            }
                        })
                    }
                });

            },

            // 新建发送消息接口
            _saveMessage(formName, isSave) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({lock:true, background:'rgba(255,255,255,0.5)'});

                        // 根据不同的tab传递不同的参数
                        let apiUrl = '';
                        let params = {};
                        if(this.dialogInfo.id.length > 0){
                            apiUrl = 'rest/api/msg/editBaseMsg';
                            params = {
                                'contractBillId': this.selectedBillId,
                                'id': this.dialogInfo.id,
                                'supplierIds':this.dialogInfo.supplierIds.length > 0 ? this.dialogInfo.supplierIds : [this.$root.stockId],
                                'messageType': this.dialogInfo.messageType,
                                'title':this.dialogInfo.title,
                                'content': this.dialogInfo.content,
                                'baseFileList':this.dialogInfo.baseFileList,
                                'readFlag': isSave ? '-2' : '-1'
                            }
                        }else{
                            apiUrl = 'rest/api/msg/createMsg';
                            params = {
                                'contractBillId': this.selectedBillId,
                                'id': this.dialogInfo.id,
                                'supplierIds':this.dialogInfo.supplierIds.length > 0 ? this.dialogInfo.supplierIds : [this.$root.stockId],
                                'messageType': this.dialogInfo.messageType,
                                'title':this.dialogInfo.title,
                                'content': this.dialogInfo.content,
                                'baseFileList':this.dialogInfo.baseFileList,
                                'readFlag': isSave ? '-2' : '-1'
                            }
                        }
                        this.$http.post(apiUrl, params).then((res)=>{
                            this.dialogVisible = false;
                            loading.close();
                            if(res.data.result) {
                                this.$message({message: '提交成功', type: 'success'});
                                // 更新列表页面
                                this.$emit('refresh');
                            } else {
                                this.$message({message: 'Error: createMsg', type: 'error'})
                            }
                        })
                    }else {
                        return false;
                    }
                });


            },
            // 上传前的验证
            beforeUpload(file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }
                if (!this.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            // 验证是否可上传
            allowUpload(name) {
                if (name) {
                    const suffix = name.substr(name.lastIndexOf('.') + 1);
                    return this.acceptFileTypes.includes(suffix);
                }
                return false;
            },

            // 上传错误
            uploadError() {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'});
            },
            // 上传成功
            uploadedSuccess(response, file, fileList) {
                if(fileList.length){
                    this.dialogInfo.baseFileList = fileList.map(item =>{
                        if(item){
                            return this._formatUploadFile(item);
                        }
                    })
                }

                // this.dialogInfo.baseFileList = this.dialogInfo.baseFileList.concat(this._formatUploadFile(file));
                // console.log(this.dialogInfo.baseFileList, 9999)
            },
            // 删除文件
            removeFile(file) {
                this.dialogInfo.baseFileList = this.dialogInfo.baseFileList.filter(item => item.uid !== file.uid);
            },
            // 格式化上传文件内容
            _formatUploadFile(file) {
                if (file) {
                    if (file.response) {
                        let fileInfo = file.response.basefiles[0];
                        return {
                            bizTableName: fileInfo.biztablename,
                            bizTablePkName: fileInfo.biztablepkname,
                            bizTablePkValue: fileInfo.biztablepkvalue,
                            fid: fileInfo.fid,
                            fileCatagoryId: fileInfo.filecatagoryid,
                            fileDesc: fileInfo.filedesc,
                            fileOldName: fileInfo.fileoldname,
                            name: fileInfo.fileoldname,
                            fileName: fileInfo.filename,
                            filePath: fileInfo.filepath,
                            fileSize: fileInfo.filesize,
                            fileType: fileInfo.filetype,
                            sort: fileInfo.sort
                        }
                    } else {
                        return file;
                    }
                }
            },
            // 初始化数据
            initDialogInfo() {
                this.dialogInfo = {
                    id: '', // 消息ID
                    messageId: '',
                    messageResponseId: '',
                    messageType: '',
                    supplierIds: [], // 供应商ID
                    readFlag: '',
                    title: '', // 消息主题
                    content: '', // 消息内容
                    baseFileList: [] // 上传的文件列表
                }
            },
            cancel() {
                this.dialogVisible = false;
                this.resetForm();
            },
            // 重置表单
            resetForm() {
                this.$refs['messageForm'].resetFields();
                this.initDialogInfo();
            },
            // 显示消息回复的弹出框
            showMessageReply (item) {
                this.dialogVisible = true;
                this.isReply = true;
                this.isReadOnly = false;
                this.title = '消息回复';
                this.messageContentTitle = '消息回复内容：'; // 设置消息内容的标题
                this.dialogInfo.messageResponseId = item.responseId;
                this.dialogInfo.messageId = item.messageId;
                this.dialogInfo.title = item.title ? item.title : '缺省'; // 回显消息
            },
            showMessageDialog (isAppend = false) {
                this.selectedBillId = '';
                this.selectedBillFname = '';
                this.dialogVisible = true;
                this.isReadOnly = false;
                this.isAppend = isAppend;
                this.isReply = false;
                this.isBatch = false;
                this.title = '消息发起';
                this.messageContentTitle = '消息内容：'; // 设置消息内容的标题
            },
            showEidtMessageDialog (item) {
                this.dialogInfo.fname = item.contractBillName;
                this.selectedBillId = item.contractBillId;
                this.selectedBillFname = item.contractBillName;
                this.dialogInfo.id = item.messageId || item.id;
                this.dialogInfo.messageType = item.messageType;
                this.dialogInfo.readFlag = item.readFlag;
                this.dialogInfo.title = item.title;
                this.dialogInfo.content = item.content;
                this.dialogInfo.supplierIds = [this.$root.stockId];
                item.baseFileList = item.baseFileList.map((fileInfo) => {
                    return {
                        bizTableName: fileInfo.bizTableName,
                        bizTablePkName: fileInfo.bizTablePkName,
                        bizTablePkValue: fileInfo.bizTablePkValue,
                        fid: fileInfo.fid,
                        fileCatagoryId: fileInfo.fileCatagoryId,
                        fileDesc: fileInfo.fileDesc,
                        fileOldName: fileInfo.fileOldName,
                        name: fileInfo.fileOldName,
                        fileName: fileInfo.fileName,
                        filePath: fileInfo.filePath,
                        fileSize: fileInfo.fileSize,
                        fileType: fileInfo.fileType,
                        sort: fileInfo.sort
                    }
                });

                this.dialogInfo.baseFileList = item.baseFileList || [];

                this.dialogVisible = true;
                this.isReadOnly = false;
                this.isAppend = false;
                this.isReply = false;
                this.isBatch = false;
                this.title = '消息编辑';
                this.messageContentTitle = '消息内容：'; // 设置消息内容的标题
            },
        }
    }
</script>

<style lang="postcss" scoped>
  .informationForm-box /deep/ {
      .el-dialog__wrapper .el-textarea__inner {
          width: 100%;
      }
  }

  .dialog-footer {
      padding: 10px 0;
      text-align: center;
  }
  .btnGroup {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/msgex/comps/informationForm.vue